import { Modal, Stack, Text, Group, Button } from "@mantine/core";

interface VerifyCompanyModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  companyName?: string;
}

export default function VerifyCompanyModal({
  opened,
  onClose,
  onConfirm,
  isLoading = false,
  companyName,
}: VerifyCompanyModalProps) {
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Text fw={600} size="lg">
          Verify Company Profile
        </Text>
      }
      centered
      size="md"
    >
      <Stack gap="md">
        <Text size="sm" c="slate.6">
          {companyName
            ? `You are about to verify the profile for "${companyName}". This action will mark the company as verified and allow them to collaborate with other companies on the platform.`
            : "This action will mark the company as verified and allow them to collaborate with other companies on the platform."}
        </Text>

        <Text size="sm" fw={500}>
          Are you sure you want to proceed?
        </Text>

        <Group justify="flex-end" mt="md">
          <Button color="primary.6" onClick={handleConfirm} loading={isLoading}>
            Verify Profile
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
